import React from 'react';
import {Button} from 'react-bootstrap';

import {FEATURE_FLAGS} from 'js/common';

const PinterestAdModeButton = ({handleEnterAdMode}) => {
    if (!FEATURE_FLAGS.isPinterestEnabled) {
        return null;
    }

    return (
        <div className="pinterest-controls">
            <Button bsStyle="success" onClick={() => handleEnterAdMode('pinterest')}>
                <div className="pull-left">
                    <div className="pinterest-logo-icon" />
                </div>
                <span className="pinterest-button-text pinterest-ad-text">Create A Pin</span>
            </Button>
        </div>
    );
};

export default PinterestAdModeButton;



// WEBPACK FOOTER //
// ./campaign_analytics/v2/campaign_analytics_page/posts/content_modal/ad_mode_buttons/pinterest.js